import { render, staticRenderFns } from "./crudServicesCustomers.vue?vue&type=template&id=40788f44&scoped=true&"
import script from "./crudServicesCustomers.vue?vue&type=script&lang=js&"
export * from "./crudServicesCustomers.vue?vue&type=script&lang=js&"
import style0 from "./crudServicesCustomers.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crudServicesCustomers.vue?vue&type=style&index=1&id=40788f44&scoped=true&lang=css&"
import style2 from "./crudServicesCustomers.vue?vue&type=style&index=2&id=40788f44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40788f44",
  null
  
)

export default component.exports